import React from 'react';
/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */

export var DropdownContext = /*#__PURE__*/React.createContext({});


//////////////////
// WEBPACK FOOTER
// ../~/reactstrap/es/DropdownContext.js
// module id = 100
// module chunks = 0